module.exports = __webpack_public_path__ + "img/24.a2a247c2.png";